import { gql } from 'graphql-request'

export const CREATE_USER_HOST_TASK_SPECIAL_WEEKEND = gql`
  mutation CREATE_USER_HOST_TASK_SPECIAL_WEEKEND(
    $userHostTaskSpecialId: Int!
    $name: String!
    $description: String!
    $levelTask: Int!
    $specialTaskType: SpecialTaskType!
    $minDay: Int!
    $minHour: Int!
    $minPoint: Float!
    $dayCompleted: Int!
    $hourCompleted: Int!
    $pointCompleted: Float!
    $completed: Boolean!
    $pointReward: Float!
    $dateInitial: String!
    $dateFinal: String!
    $received: Boolean!
    $dateReceived: String
  ) {
    createUserHostTaskSpecialWeekend(
      userHostTaskSpecialId: $userHostTaskSpecialId
      name: $name
      description: $description
      levelTask: $levelTask
      specialTaskType: $specialTaskType
      minDay: $minDay
      minHour: $minHour
      minPoint: $minPoint
      dayCompleted: $dayCompleted
      hourCompleted: $hourCompleted
      pointCompleted: $pointCompleted
      completed: $completed
      pointReward: $pointReward
      dateInitial: $dateInitial
      dateFinal: $dateFinal
      received: $received
      dateReceived: $dateReceived
    ) {
      error
      status
      data {
        id
        userHostTaskSpecialId
        userHostTaskSpecial {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        levelTask
        specialTaskType
        minDay
        minHour
        minPoint
        dayCompleted
        hourCompleted
        pointCompleted
        completed
        pointReward
        dateInitial
        dateFinal
        received
        dateReceived
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_USER_HOST_TASK_SPECIAL_WEEKEND = gql`
  query GET_USER_HOST_TASK_SPECIAL_WEEKEND(
    $userHostTaskSpecialWeekendId: Int!
  ) {
    getUserHostTaskSpecialWeekend(
      userHostTaskSpecialWeekendId: $userHostTaskSpecialWeekendId
    ) {
      error
      status
      data {
        id
        userHostTaskSpecialId
        userHostTaskSpecial {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        levelTask
        specialTaskType
        minDay
        minHour
        minPoint
        dayCompleted
        hourCompleted
        pointCompleted
        completed
        pointReward
        dateInitial
        dateFinal
        received
        dateReceived
        createdAt
        updatedAt
      }
    }
  }
`
export const GET_USERS_HOSTS_TASKS_SPECIALS_WEEKENDS = gql`
  query GET_USERS_HOSTS_TASKS_SPECIALS_WEEKENDS(
    $take: Int
    $skip: Int
    $userHostTaskSpecialId: Int
    $userId: Int
    $name: String
    $description: String
    $levelTask: Int
    $specialTaskType: SpecialTaskType
    $minDay: Int
    $minHour: Int
    $typeFilterMinPoint: TypeFilter
    $minPointInitial: Float
    $minPointFinal: Float
    $typeFilterPointReward: TypeFilter
    $pointRewardInitial: Float
    $pointRewardFinal: Float
    $typeFilterDate: TypeFilter
    $dateInitial: String
    $dateFinal: String
    $received: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getUsersHostsTasksSpecialsWeekends(
      take: $take
      skip: $skip
      userHostTaskSpecialId: $userHostTaskSpecialId
      userId: $userId
      name: $name
      description: $description
      levelTask: $levelTask
      specialTaskType: $specialTaskType
      minDay: $minDay
      minHour: $minHour
      typeFilterMinPoint: $typeFilterMinPoint
      minPointInitial: $minPointInitial
      minPointFinal: $minPointFinal
      typeFilterPointReward: $typeFilterPointReward
      pointRewardInitial: $pointRewardInitial
      pointRewardFinal: $pointRewardFinal
      typeFilterDate: $typeFilterDate
      dateInitial: $dateInitial
      dateFinal: $dateFinal
      received: $received
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        userHostTaskSpecialId
        userHostTaskSpecial {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        levelTask
        specialTaskType
        minDay
        minHour
        minPoint
        dayCompleted
        hourCompleted
        pointCompleted
        completed
        pointReward
        dateInitial
        dateFinal
        received
        dateReceived
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_USER_HOST_TASK_SPECIAL_WEEKEND_FIRST = gql`
  query GET_USER_HOST_TASK_SPECIAL_WEEKEND_FIRST(
    $id: Int
    $userHostTaskSpecialId: Int
    $userId: Int
    $name: String
    $description: String
    $levelTask: Int
    $specialTaskType: SpecialTaskType
    $minDay: Int
    $minHour: Int
    $typeFilterMinPoint: TypeFilter
    $minPointInitial: Float
    $minPointFinal: Float
    $typeFilterPointReward: TypeFilter
    $pointRewardInitial: Float
    $pointRewardFinal: Float
    $typeFilterDate: TypeFilter
    $dateInitial: String
    $dateFinal: String
    $received: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getUserHostTaskSpecialWeekendFirst(
      id: $id
      userHostTaskSpecialId: $userHostTaskSpecialId
      userId: $userId
      name: $name
      description: $description
      levelTask: $levelTask
      specialTaskType: $specialTaskType
      minDay: $minDay
      minHour: $minHour
      typeFilterMinPoint: $typeFilterMinPoint
      minPointInitial: $minPointInitial
      minPointFinal: $minPointFinal
      typeFilterPointReward: $typeFilterPointReward
      pointRewardInitial: $pointRewardInitial
      pointRewardFinal: $pointRewardFinal
      typeFilterDate: $typeFilterDate
      dateInitial: $dateInitial
      dateFinal: $dateFinal
      received: $received
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        id
        userHostTaskSpecialId
        userHostTaskSpecial {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        levelTask
        specialTaskType
        minDay
        minHour
        minPoint
        dayCompleted
        hourCompleted
        pointCompleted
        completed
        pointReward
        dateInitial
        dateFinal
        received
        dateReceived
        createdAt
        updatedAt
      }
    }
  }
`

export const CHECK_CREATE_USER_HOST_TASK_SPECIAL_WEEKEND = gql`
  mutation CHECK_CREATE_USER_HOST_TASK_SPECIAL_WEEKEND(
    $userHostTaskSpecialId: Int!
  ) {
    checkCreateUserHostTaskSpecialWeekend(
      userHostTaskSpecialId: $userHostTaskSpecialId
    ) {
      error
      status
      data {
        id
        userHostTaskSpecialId
        userHostTaskSpecial {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        levelTask
        specialTaskType
        minDay
        minHour
        minPoint
        dayCompleted
        hourCompleted
        pointCompleted
        completed
        pointReward
        dateInitial
        dateFinal
        received
        dateReceived
        createdAt
        updatedAt
      }
    }
  }
`
